import React from 'react'
    import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
    import { Toaster } from 'react-hot-toast'
    import Navbar from './components/Navbar'
    import Home from './pages/Home'
    import About from './pages/About'
    import Contact from './pages/Contact'
    import Footer from './components/Footer'

    function App() {
      return (
        <Router>
          <div className="min-h-screen bg-gray-50" data-component-path="client/src/App.jsx" data-component-line="1:4" data-component-id="client/src/App.jsx:1:4">
            <Navbar />
            <main data-component-path="client/src/App.jsx" data-component-line="2:6" data-component-id="client/src/App.jsx:2:6">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </main>
            <Footer />
            <Toaster position="top-right" />
          </div>
        </Router>
      )
    }

    export default App